<template>
	<section class="col-span-4 panel lg:h-32 lg:flex lg:justify-between lg:items-center lg:justify-items-center">
		<div class="mb-4 lg:mb-0">
			<div class="text-2xl font-medium">
				{{ nextPaymentDueText }}
			</div>
			<div
				v-if="hasAutoPay"
				class="mt-2 dark:text-mx-gray-400 lg:mt-0"
			>
				{{ autopayMethodText }}
			</div>
		</div>
		<div>
			<div
				v-if="!hasAutoPay"
				class="flex w-full text-center"
			>
				<LinkButton
					:to="`/billing/invoices/${nextPaymentInvoiceId}`"
					class="w-full lg:w-56"
				>
					{{ t('account-page.buttons.pay-now') }}
				</LinkButton>
			</div>
			<div
				v-else
				class="flex"
			>
				<LinkButton
					to="/billing/payment-methods"
					variant="outline"
					class=""
				>
					{{ t('account-page.buttons.cancel-or-change') }}
				</LinkButton>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
	hasAutoPay: boolean
	nextPaymentDueText: string
	autopayMethodText?: string
	nextPaymentInvoiceId?: string | number
}

defineProps<Props>()

const { t } = useI18n()
</script>
